import GuestAPI from '@utils/plugins/GuestAPI';

const TableOrderService = {
  getMenu: (tableCode, qs) => {
    return GuestAPI.get(`v1/businesses/${tableCode}/table-menu?qs=${qs}`);
  },
  verifyLocation: (payload) => {
    return GuestAPI.post('v1/users/location/verify', {...payload});
  },
  phoneNumber: (phoneNumber, reCaptchaToken) => {
    return GuestAPI.post('v1/users/phone-number/verify', {phoneNumber, reCaptchaToken});
  },
  verifyPhoneNumber: (phoneNumber, code, reCaptchaToken) => {
    return GuestAPI.post('v1/users/verification-code/validate', {phoneNumber, code, reCaptchaToken});
  },
  createOrder: (businessId, tableId, payload) => {
    return GuestAPI.post(`v1/orders/businesses/${businessId}/table/${tableId}/create`, {...payload});
  },
  getOrder: (id, phoneNumber) => {
    return GuestAPI.get(`v1/users/orders/details/${id}?phoneNumber=${phoneNumber}`);
  },
};

export default TableOrderService;
